
export enum WorkingOrderListOrderBy {
    ACCOUNT = "ACCOUNT",
    ASX_CODE = "ASX_CODE",
    LAST_UPDATED = "LAST_UPDATED",
    CREATED = "CREATED",
    ORDER_TREE = "ORDER_TREE"
}
